<template>
  <div
    class="cultureCycleAdd"
    style="width: 97.8%; border: 1px solid #e0e0e0; margin-left: 14px"
  >
    <div class="titleForm-container">增加养殖周期</div>
    <div class="content-form-container">
      <div class="main-container-form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="ruleForm"
        >
          <el-form-item label="基地" prop="fishBaseName">
            <el-select
              v-model="ruleForm.fishBaseName"
              placeholder="请选择"
              style="width: 100%"
              @change="getChangeFishPondNoBatch"
            >
              <el-option
                v-for="(item, index) in baseList"
                :key="index"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-row :gutter="3">
            <el-form-item label="塘口" prop="fishPondName" required>
              <el-col :span="19" :md="{ span: 18 }">
                <el-form-item>
                  <el-select
                    placeholder="请选择"
                    size="medium"
                    @change="getLastBatch"
                    style="width: 100%"
                    v-model="ruleForm.fishPondName"
                  >
                    <el-option
                      v-for="(item, index) in fishPondNoBatch"
                      :key="index"
                      :label="item.fishPondName"
                      :value="item.fishPondId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" :md="{ span: 5 }" :offset="0.8">
                <el-form-item prop="batch">
                  <el-input
                    :disabled="showLastBatch"
                    type="text"
                    :maxlength="num"
                    v-model.number="ruleForm.batch"
                    style="width: 100%"
                    size="medium"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1" :offset="0.5">
                <span>批</span>
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item label="开始时间" prop="startDate">
            <el-col>
              <el-date-picker
                type="date"
                placeholder="选择日期"
                :picker-options="startPickerTimeOptions"
                v-model="ruleForm.startDate"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="清塘时间" prop="clearedDate">
            <el-col>
              <el-date-picker
                type="date"
                disabled
                :picker-options="clearPickerTimeOptions"
                v-model="ruleForm.clearedDate"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="主养品种" class="mainVarietyFormItem">
            <el-row :gutter="10" type="flex" class="mainVarietyRow">
              <el-col :span="12">
                <el-select
                  v-model="mainCategoryItem"
                  clearable
                  filterable
                  class="mainVarietySelect"
                  placeholder="鱼分类"
                  size="medium"
                  @change="onMainCategoryChange"
                >
                  <el-option
                    v-for="item in fishGetCategory"
                    :key="item.key"
                    :label="item.value"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-select
                  v-model="mainFishItem"
                  clearable
                  filterable
                  :disabled="!mainCategoryItem"
                  class="mainVarietySelect"
                  :placeholder="mainCategoryItem ? '鱼种' : '请先选择鱼分类'"
                  size="medium"
                >
                  <el-option
                    v-for="item in fishGetCategoryName"
                    :key="item.key"
                    :label="item.value"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="饵料系数" prop="foodCoefficient">
            <el-input
              v-model="ruleForm.foodCoefficient"
              clearable
              placeholder="可空"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="备注" prop="mark">
            <el-input
              v-model="ruleForm.mark"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              :maxlength="num50"
              placeholder="请输入备注"
              style="width: 100%"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-col :span="8">
              <el-button
                class="save-btn"
                type="primary"
                @click="addSubmitForm('ruleForm')"
                >保存</el-button
              >
            </el-col>
            <el-col :span="8">
              <el-button class="cancel-btn" @click="cancelForm('ruleForm')"
                >取消</el-button
              >
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
export default {
  name: "cultureCycleAdd",
  data() {
    return {
      mainCategoryItem: null,
      mainFishItem: null,
      showLastBatch: false, // 弹框周期是否添+
      num: 4,
      num50: 50,
      startPickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      clearPickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      baseList: [], //基地列表
      ruleForm: {
        fishBaseName: "",
        fishPondName: "",
        batch: "",
        startDate: "",
        clearedDate: "",
        mark: "",
        foodCoefficient: "",
      },
      rules: {
        fishBaseName: [
          { required: true, message: "请选择基地", trigger: "change" },
        ],
        fishPondName: [
          { required: true, message: "请选择塘口", trigger: "change" },
        ],
        batch: [
          {
            required: true,
            min: 1,
            max: 9999,
            pattern: /^[1-9]*$/,
            message: "批次格式有误",
            trigger: "blur",
          },
        ],
        startDate: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change",
          },
        ],
        foodCoefficient: [
          { validator: this.validateFoodCoefficient, trigger: "blur" },
        ],
        mark: [{ required: false, message: "请输入备注", trigger: "blur" }],
      },
    };
  },
  methods: {
    validateFoodCoefficient(rule, value, callback) {
      if (value !== 0 && !value) {
        callback();
      } else if (isNaN(value)) {
        callback(new Error("该值只能是数值类型"));
      } else if (value <= 0) {
        callback(new Error("请输入大于0的数值"));
      } else if (!/^\d+(\.\d{1,2})?$/.test(String(value))) {
        callback(new Error("小数点后最多两位小数"));
      } else {
        callback();
      }
    },
    onMainCategoryChange(val) {
      this.mainFishItem = null;
      if (!val) {
        return;
      }
      this.getFishGetCategoryName(val.key).catch((err) => {
        console.dir(err);
      });
    },
    validateMainVarietyForSave() {
      if (this.mainCategoryItem && !this.mainFishItem) {
        this.$message.warning("已选择鱼分类，请选择鱼种");
        return false;
      }
      return true;
    },
    toMainFishPayload() {
      const c = this.mainCategoryItem;
      const f = this.mainFishItem;
      return {
        mainFishCategoryId: c ? c.key : null,
        mainFishCategoryName: c ? c.value : null,
        mainFishId: f ? f.key : null,
        mainFishName: f ? f.value : null,
        foodCoefficient: (() => {
          const v = this.ruleForm.foodCoefficient;
          if (v === "" || v == null) {
            return null;
          }
          const n = Number(v);
          return isNaN(n) ? null : n;
        })(),
      };
    },
    ...mapActions(modules.cultureCycle, [
      "addFishBatch", // 添加周期
    ]),
    ...mapActions(modules.base, [
      "getBaseList", //基地信息
    ]),
    ...mapActions(modules.pond, [
      "getFishPondNoBatch", // 基地下已清塘的鱼塘
    ]),
    ...mapActions(modules.fish, [
      "getFishGetCategory",
      "getFishGetCategoryName",
    ]),
    //塘口下拉--改变
    getLastBatch(val) {
      this.mainCategoryItem = null;
      this.mainFishItem = null;
      this.ruleForm.foodCoefficient = "";
      let item = this.fishPondNoBatch.find((f) => f.fishPondId == val);
      if (item) {
        if (item.lastClearedDate === null) {
          // 判断是否为清塘 如果最后时间为null则可自动填写批次
          this.showLastBatch = false;
          this.ruleForm.batch = "";
        } else {
          // this.ruleForm.fishPondName.filter(f => f.this.ruleForm.batch);
          this.ruleForm.batch = item.lastBatch + 1;
          this.showLastBatch = true;
        }
      }
    },
    // 获取基地改变时塘口的数据
    getChangeFishPondNoBatch() {
      this.mainCategoryItem = null;
      this.mainFishItem = null;
      this.ruleForm.foodCoefficient = "";
      this.ruleForm.fishPondName = "";
      this.ruleForm.batch = "";
      this.showLastBatch = false;
      this.getFishPondNoBatch(this.ruleForm.fishBaseName)
        .then((rsp) => {
          if (rsp.status === 200) {
            if (this.fishPondNoBatch[0]) {
              this.ruleForm.fishPondName = this.fishPondNoBatch[0].fishPondId;
              if (this.fishPondNoBatch[0].lastClearedDate === null) {
                // 判断是否为清塘 如果最后时间为null则可自动填写批次
                this.showLastBatch = false;
                this.ruleForm.batch = "";
              } else {
                // this.ruleForm.fishPondName.filter(f => f.this.ruleForm.batch);
                this.ruleForm.batch = this.fishPondNoBatch[0].lastBatch + 1;
                this.showLastBatch = true;
              }
            }
          }
        })
        .catch((err) => {
          console.dir(err);
        });
    },
    //保存周期
    addSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.validateMainVarietyForSave()) {
            return;
          }
          let obj = {
            fishPondId: this.ruleForm.fishPondName,
            batch: this.ruleForm.batch,
            startDate: this.ruleForm.startDate,
            remark: this.ruleForm.mark,
            ...this.toMainFishPayload(),
          };
          this.addFishBatch(obj)
            .then((rsp) => {
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                history.go(-1);
                this.mainCategoryItem = null;
                this.mainFishItem = null;
                this.ruleForm = {
                  fishBaseName: "",
                  fishPondName: "",
                  batch: "",
                  startDate: "",
                  clearedDate: "",
                  mark: "",
                  foodCoefficient: "",
                };
                this.$refs[formName].resetFields();
              }
            })
            .catch((err) => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error",
              });
              // this.$message.error(err.response.data);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      history.go(-1);
    },
  },
  async mounted() {
    this.getFishGetCategory().catch((err) => {
      console.dir(err);
    });
    //获取基地
    let obj = {
      fishBaseName: this.fishBaseName,
    };
    let baseList = await this.getBaseList(obj);
    this.baseList = baseList;
    this.ruleForm.fishBaseName = baseList[0].key;
    this.getChangeFishPondNoBatch();
  },
  computed: {
    ...mapState(modules.cultureCycle, ["cycleList"]),
    ...mapState(modules.pond, ["fishPondNoBatch"]),
    ...mapState(modules.fish, ["fishGetCategory", "fishGetCategoryName"]),
  },
};
</script>

<style lang="stylus">
.cultureCycleAdd
  .mainVarietyFormItem
    .el-form-item__content
      line-height: normal
  .mainVarietyRow
    width: 100%
    flex-wrap: nowrap
  .mainVarietySelect
    width: 100%
  .content-form-container
    .main-container-form
      .ruleForm
        .el-form-item
          &:nth-child(n+4)
            .el-form-item__label
                padding-left: 10px;
</style>
